import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import "jquery-match-height/jquery.matchHeight";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


import "@fortawesome/fontawesome-free/js/fontawesome.min";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/regular.min";
import "@fortawesome/fontawesome-free/js/brands.min";

import {animations} from "./animations";
import {sliders} from "./sliders";
import {filters} from "./filters";


/****************************************************************************
 * Theme scripts.
 ****************************************************************************/


window.addEventListener('load', function() {
    AOS.refresh();
});

window.onload = function() {
    document.body.classList.add('is-ready');
};



(function( $ ){
    'use strict';

    setTimeout( () => {

        AOS.init({  duration: 1200});
        animations.init();
        sliders.init();
        filters.init();

        Fancybox.bind("[data-fancybox]", {
            // Your custom options
        });



    }, 1 );

    setTimeout( () => {


    }, 2000 );

    $(window).on('scroll', function (event) {
        AOS.refresh();
    });


} )( jQuery );
/***************
 * After theme scripts
 ***************/


// // Each time the window updates, refresh ScrollTrigger and then update LocomotiveScroll
// ScrollTrigger.addEventListener( 'refresh', () => scroll.update() );
//
// // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
// ScrollTrigger.refresh();
